<template>
  <div v-if="visible" style="height: 50px">
    <button @click="move(1)" value="1">1</button>
  </div>
</template>

<script>
export default {
  computed: {
    visible() {
      return process.env.NODE_ENV !== 'production';
    },
  },
  methods: {
    move(i) {
      let url = undefined;
      switch (i) {
        case 1:
          url = 'http://192.168.35.213:3001';
          break;

        default:
          break;
      }
      if (url) location.href = url;
    },
  },
};
</script>
